"use strict";

function getSocialLawyer() {
  var linkedin = $('#linkedin'),
      facebook = $('#facebook'),
      twitter = $('#twitter'),
      instagram = $('#instagram'),
      skype = $('#skype'),
      youtube = $('#youtube'),
      google = $('#google');
  var dataLinkedin = $('[data-network="1"]'),
      dataFacebook = $('[data-network="2"]'),
      dataTwitter = $('[data-network="3"]'),
      dataInstagram = $('[data-network="4"]'),
      dataSkype = $('[data-network="5"]'),
      dataYoutube = $('[data-network="6"]'),
      dataGoogle = $('[data-network="7"]');
  $('[data-social-network="1"]').attr('data-social-id', dataLinkedin.data('social-id'));
  $('[data-social-network="2"]').attr('data-social-id', dataFacebook.data('social-id'));
  $('[data-social-network="3"]').attr('data-social-id', dataTwitter.data('social-id'));
  $('[data-social-network="4"]').attr('data-social-id', dataInstagram.data('social-id'));
  $('[data-social-network="5"]').attr('data-social-id', dataSkype.data('social-id'));
  $('[data-social-network="6"]').attr('data-social-id', dataYoutube.data('social-id'));
  $('[data-social-network="7"]').attr('data-social-id', dataGoogle.data('social-id'));

  if (dataLinkedin.val() !== '') {
    $('[data-social-network="1"]').addClass('js-input-data');
  }

  if (dataFacebook.val() !== '') {
    $('[data-social-network="2"]').addClass('js-input-data');
  }

  if (dataTwitter.val() !== '') {
    $('[data-social-network="3"]').addClass('js-input-data');
  }

  if (dataInstagram.val() !== '') {
    $('[data-social-network="4"]').addClass('js-input-data');
  }

  if (dataSkype.val() !== '') {
    $('[data-social-network="5"]').addClass('js-input-data');
  }

  if (dataYoutube.val() !== '') {
    $('[data-social-network="6"]').addClass('js-input-data');
  }

  if (dataGoogle.val() !== '') {
    $('[data-social-network="7"]').addClass('js-input-data');
  }

  linkedin.val(dataLinkedin.val());
  twitter.val(dataTwitter.val());
  facebook.val(dataFacebook.val());
  instagram.val(dataInstagram.val());
  skype.val(dataSkype.val());
  youtube.val(dataYoutube.val());
  google.val(dataGoogle.val());
}